import { ChargeTypeEnum } from '../../../enums/charge-type.enum';
import { PricingPresetRequirementEnum } from '../../../enums/pricing-preset-requirement.enum';
import { TaxRateTypeEnum } from '../../../enums/tax-rate-type.enum';
import { PricingItemTypeEnum } from '../../pricing-items/enums/pricing-item-type.enum';

/**
 * Vehicle category pricing item template DTO
 */
export class VehicleCategoryPricingItemTemplateDto {
	id?: number;
	uuid!: string;
	name!: string;
	description?: string;
	type!: PricingItemTypeEnum;
	taxRateType!: TaxRateTypeEnum;
	hasUnits?: boolean;
	maxUnits?: number;
	presetRequirement?: PricingPresetRequirementEnum;
	chargeType?: ChargeTypeEnum;
}
